// 通知公告
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid
            :stripe="true" border="default" :row-config="{ isHover: true }" show-overflow height="100%"
            ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
            @custom="$vxeTableUtil.customHandle">

            <template #showTypeName="{row}">
              <span>{{getBulletinType(row)}}</span>
            </template>

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">新增
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="标题名称:" field="name">
                  <template v-slot>
                    <el-input v-model="searchProjectName" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="通知公告类型:" field="name">
                  <template v-slot>
                    <el-input v-model="searchProjectCode" size="small" clearable/>
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {dictType, loadDictData} from "@/config/dictType";
import {indexPageMixins} from "@/mixins/tabChang";

export default {
  mixins: [indexPageMixins],
  components: {editView, pager},
  data() {
    return {
      total: 0,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      gridData: {},
      showEdit: false,
      editViewDataUpdateFlag: false,
      vxeOption: {},
      searchProjectCode: '',
      searchProjectName: '',
      // 查询参数
      formData: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        projectCode: '',
        projectName: ''
      },
      bulletinTypeOption: [],
    };
  },
  computed: {

  },
  mounted() {
    loadDictData();
    // this.initTableList();
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.initTableList()
      }
    }
  },
  methods: {
    toFilterData() {
            this.searchEvent();
     },
    getTableData() {
      this.initTableList()
    },

    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 分页功能
    changeTablePage(page, flag) {
      console.log('分页数据', page, this.formData)
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },
    // 搜索
    searchEvent() {
      this.formData.projectCode = this.searchProjectCode
      this.formData.projectName = this.searchProjectName
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()

    },

    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.basBulletin.getPageDataUrl,
        param: this.formData,
        method: 'post',
        height: '800px',
        columns: [
          {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
          { title: '标题', field: 'title', width: 150, fixed: 'left' },
          { title: '通知公告类型', field: 'bulletinTypeName', width: 150,},
          { title: '是否置顶', field: 'isTop', width: 150, slots: {
              default: ({row}) => {
                if (row.isTop == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>否</span>
                    </div>
                  ];
                } else if (row.isTop == 1) {
                  return [
                    <div class="txt-status">
                      <span>是</span>
                    </div>
                  ];
                }
              }
            }
          },
          { title: '是否发布', field: 'isPublic', width: 150, slots: {
              default: ({row}) => {
                if (row.isPublic == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>否</span>
                    </div>
                  ];
                } else if (row.isPublic == 1) {
                  return [
                    <div class="txt-status">
                      <span>是</span>
                    </div>
                  ];
                }
              }
            }
          },
          { width: 47, fixed: 'right', title: '', sortable: false, slots: {
              default: ({row}) => {
                return [
                  <div>
                    <a href="javascript:void(0);" class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        ]
      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}</style>
